(function(){

  'use strict';


  function pxPrinterToner() {
    return {
      restrict: 'EA',
      scope: {
        printerData: '=printerData'
      },
      templateUrl: 'app/directives/printerTonerDirective/printer-toner.template.html',
      link: function(scope) {

        scope.printer = scope.printerData.printer;

      }
    }
  }

  pxPrinterToner.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxPrinterToner', pxPrinterToner);

})();